import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "@gravity-ui/uikit";
import UserCard from "@/components/ui/UserCard";
export var UserList = function (props) {
    return (_jsx(Flex, { direction: "column", gap: 3, children: props.data.items.length > 0 ? (props.data.items.map(function (user) { return (_jsx(UserCard, { user: user, onDetailsClick: props.onDetailsClick }, user.id)); })) : (_jsx("div", { children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043D\u0435 \u043D\u0430\u0438\u0306\u0434\u0435\u043D\u044B" })) }));
};
